import React from 'react';
import PropTypes from 'prop-types';
import { TopToolbar, ListButton } from 'react-admin';

const TopicActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} record={data} />
  </TopToolbar>
);

TopicActions.propTypes = {
  basePath: PropTypes.string,
  data: PropTypes.shape({}),
};

TopicActions.defaultProps = {
  basePath: '',
  data: {},
};

export default TopicActions;
